import { Row, Col } from 'components-antd';
import { Icons } from 'pages/Workshop/Icons';
import { ColumnsDropdown } from '../../ColumnsDropdown';
import { SearchFieldWithDebounce } from 'components';

import styles from './styles.module.scss';
import { useState } from 'react';
import {
  requestResetSymphonySearchAction,
  requestUpdateSymphonySearchAction,
} from 'store/actions/symphony';

export const HeaderTop = () => {
  const [showSearch, setShowSearch] = useState(false);

  return (
    <div className={styles.headerTop}>
      <Row>
        <Col xs={0} lg={8} />
        <Col xs={15} lg={8}>
          <h1>Symphony</h1>
        </Col>
        <Col xs={9} lg={8} className={styles.btnContainer}>
          {showSearch ? (
            <div className={styles.searchWrapper}>
              <SearchFieldWithDebounce
                className={styles.inputWrap}
                classNameInput={styles.searchInput}
                iconClassName={styles.icon}
                resetAction={requestResetSymphonySearchAction}
                sendAction={requestUpdateSymphonySearchAction}
                isLoading={false}
                placeholder="Search"
                isTransactionAggregate
                isExpandedVersion
                onClearCallback={() => {
                  setShowSearch(false);
                }}
              />
            </div>
          ) : (
            <div
              className={styles.btn}
              onClick={() => {
                setShowSearch(true);
              }}
            >
              <Icons variant={Icons.SEARCH} color="#515151" />
            </div>
          )}
          <ColumnsDropdown>
            <Icons variant={Icons.SETTINGS} className={styles.btn} />
          </ColumnsDropdown>
        </Col>
      </Row>
    </div>
  );
};
